/**
 *
 * @type {import('@webreact/webreactor/dist/Router/types').ComponentInit[]}
 */
const components = [
    {
        file: (async () => (await (import('./components/scroll'))).default),
        target: 'body'
    },
    {
        file: (async () => (await (import('./components/hero'))).default),
        target: '.hero'
    },
    {
        file: (async () => (await (import('./components/toggle'))).default),
        target: '.js-toggle'
    },
    {
        file: (async () => (await (import('./components/cta-scroll'))).default),
        target: '.call-to-action__dots'
    },
    {
        file: (async () => (await (import('./components/tabs'))).default),
        target: '.js-tabs'
    },
    {
        file: (async () => (await (import('./components/expand'))).default),
        target: '.js-expand'
    },
    {
        file: (async () => (await (import('./components/opening-hours'))).default),
        target: '.js--opening-hours'
    },
    {
        file: (async () => (await (import('./components/service-package'))).default),
        target: '.js--service-package'
    },
    {
        file: (async () => (await (import('./components/modal'))).default),
        target: '.js--modal'
    },{
        file: (async () => (await (import('./components/google-maps'))).default),
        target: '.js-locations-google-maps'
    },
    {
        file: (async () => (await (import('./components/swiper'))).default),
        target: '.swiper'
    },
    {
        file: (async () => (await (import('./components/sidebar-filters'))).default),
        target: '.search-sidebar'
    },
    {
        file: (async () => (await (import('./components/sidebar-filters-lease'))).default),
        target: '.search-sidebar--lease'
    },
    {
        file: (async () => (await (import('./components/gform-tradein'))).default),
        target: '.gform_tradein_wrapper'
    },
    {
        file: (async () => (await (import('./components/gform-servicing'))).default),
        target: '.gform_servicing_wrapper'
    },
    {
        file: (async () => (await (import('./components/gform-finance-calculator'))).default),
        target: '.gform_finance_calculator_wrapper'
    },
    {
        file: (async () => (await (import('./routes/single/autobedrijf_voertuig'))).default),
        target: '.single-autobedrijf_voertuig'
    },
    {
        file: (async () => (await (import('./components/gwp-slider'))).default),
        target: '.gwp_slider'
    },
    {
        file: (async () => (await (import('./components/gallery'))).default),
        target: '.gallery'
    },
    {
        file: (async () => (await (import('./components/new-models'))).default),
        target: '.new-models'
    },
    {
        file: (async () => (await (import('./components/share'))).default),
        target: '.js--share'
    },
    {
        file: (async () => (await (import('./components/micromodal'))).default),
        target: '[data-micromodal-trigger]'
    },
    {
        file: (async () => (await (import('./components/copy-to-clipboard'))).default),
        target: '.js--copy-to-clipboard'
    },
    {
        file: (async () => (await (import('./components/wc-checkout'))).default),
        target: '.woocommerce-checkout'
    },
    {
        file: (async () => (await (import('./components/wc-quantity'))).default),
        target: '.quantity'
    },
    {
        file: (async () => (await (import('./components/header'))).default),
        target: '.header'
    },
]

const routelist = []

export {
    components, routelist
}